import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";

interface SubscriptionBannerProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function SubscriptionBanner({
  title = "Upgrade your provider subscription",
  description = "Unlock unlimited listings, broader category coverage, priority placement, and listing analytics.",
  actionLabel,
  onAction,
}: SubscriptionBannerProps) {
  const navigate = useNavigate();
  const {
    user
  } = useAuth();
  const handleUpgradeClick = () => {
    if (onAction) {
      onAction();
      return;
    }

    if (user) {
      navigate('/pricing');
    } else {
      navigate(`/auth?tab=signup&redirect=${encodeURIComponent('/pricing')}`);
    }
  };
  return <Alert className="rounded-md border-amber bg-amber-soft">
      <AlertTitle className="text-brand-ink">{title}</AlertTitle>
      <AlertDescription className="mt-2 flex flex-col items-start gap-4 text-brand-slate sm:flex-row sm:items-center">
        <span>{description}</span>
        <Button onClick={handleUpgradeClick} className="bg-brand-ink text-white hover:bg-brand-charcoal">
          {actionLabel ?? (user ? "Upgrade now" : "Sign up to upgrade")}
        </Button>
      </AlertDescription>
    </Alert>;
}
